"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReactions = void 0;
const QueryTypes_1 = require("./QueryTypes");
const getReactions = (firebase) => __awaiter(void 0, void 0, void 0, function* () {
    const query = new QueryTypes_1.SapporoQuery('reactions');
    query.orderBy = new QueryTypes_1.SapporoQueryOrderBy('value', 'asc');
    const queryResults = yield firebase.query(query);
    //    console.log('GOT EM', queryResults );
    return [...queryResults.data.map((r) => r.data)];
});
exports.getReactions = getReactions;
exports.default = exports.getReactions;
